'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionService',
    function TransactionService($resource,
                                $rootScope,
                                SiteConfigModel,
                                TransactionsModel,
                                TransactionSortModel,
                                TransactionSearchModel,
                                TransactionRepository) {
      var self = this;
      var CURRENT_TRANSACTIONS_REFRESHED = 'current_transactions_refreshed';

      self.search = '';

      self.getTransactions = function () {
        var transactionCountUri = TransactionSearchModel.url('count');
        TransactionRepository.runTransactionCount(transactionCountUri)
          .then(function(response) {
            if (response.numberOfTransactions < TransactionsModel.maxTransactions()) {
              TransactionsModel.transactionCount(response.numberOfTransactions);
              TransactionsModel.maxTransactions(response.maxNumberOfTransactions);
              self.getTransactionList();
            } else {
              TransactionsModel.transactionCount(response.numberOfTransactions);
              TransactionsModel.maxTransactions(response.maxNumberOfTransactions);
              TransactionsModel.transactions([]);
            }
          })
          .catch();

      };
      
      self.getTransactionList = function() {
        var transactionsUri = TransactionSearchModel.url('filter');
        TransactionsModel.loading(true);
        TransactionsModel.transactions([]);

        return TransactionRepository.runTransactionSearch(transactionsUri)
          .then(function (results) {
            TransactionsModel.transactions(results);
            $rootScope.$broadcast(CURRENT_TRANSACTIONS_REFRESHED, undefined);
            self.getTransactionByCurrency();
            return results;
          })
          .finally(function () {
            TransactionsModel.loading(false);
          });
      };

      self.getTransactionByCurrency = function(){
        TransactionsModel.transactionCurrency([]);
        return _.map(TransactionsModel.transactions(), function(transaction){

          var oldtransactionCurrency = _.find(TransactionsModel.transactionCurrency(), ['key', transaction.details.billedCurrency]);
          if(oldtransactionCurrency !== undefined){
            oldtransactionCurrency.value.push(transaction);
          } else {
            var transactionKeyValue = {
              'key': transaction.details.billedCurrency,
              'value': [transaction]
            };
            TransactionsModel.transactionCurrency().push(transactionKeyValue);
          }
        });
      };

      self.loadAllAllocations = function () {
        var allocationUri = TransactionSearchModel.url('allocations');
        return TransactionRepository.fetchAllocations(allocationUri)
          .then(function (allocationMap) {
            _.forEach(TransactionsModel.transactions(), function(transaction) {
              transaction.allocations = allocationMap[transaction.id];
            });
          });
      };

      self.onCurrentTransactionsRefreshed = function (scope, handler) {
        scope.$on(CURRENT_TRANSACTIONS_REFRESHED, function () {
          handler();
        });
      };

      self.isMeetings360 = function (transaction) {
        return SiteConfigModel.isMeetings360() && self.isLinked(transaction);
      };

      self.isLinked = function (transaction) {
        return _.get(transaction, 'transactionThirdPartyData', []).length > 0;
      };

      TransactionSearchModel.onBillingCycleChanged($rootScope, function () {
        self.getTransactions();
      });
    }
  );



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionService.js
// module id = 654
// module chunks = 0